import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BildverifizierungComponent } from './bildverifizierung/bildverifizierung.component';

const routes: Routes = [
    {
        path: ':projektId/bildverifizierung',
        component: BildverifizierungComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
